import { render } from "./AcceuilComponent.vue?vue&type=template&id=2aaf175c&scoped=true"
import script from "./AcceuilComponent.vue?vue&type=script&lang=js"
export * from "./AcceuilComponent.vue?vue&type=script&lang=js"

import "./AcceuilComponent.vue?vue&type=style&index=0&id=2aaf175c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaf175c"]])

export default __exports__